module.exports = __webpack_public_path__ + "img/summary-jobs-count.d9ab11eb.svg";